export enum ToDoPriority {
	HIGH = "HIGH",
	MEDIUM = "MEDIUM",
	LOW = "LOW",
}
